// eslint-disable-next-line prettier/prettier
import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    heading: {
        color: '#272727',
        opacity: '1',
        marginTop: '5px',
        marginBottom: '5px',
        font: 'normal normal bold 24px/29px Montserrat'
    },
    row: {
        font: 'normal normal normal 12px/18px Montserrat',
        letterSpacing: '0px',
        color: '#4E4E4E',
        marginBottom: '0px',
        marginTop: '0px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    },
    overflowText: { textOverflow: 'ellipsis', overflow: 'hidden', width: '150px'},
    notificationContainer: {
        border: '1px solid #E0E0E0',
        borderRadius: '12px',
        padding: '20px',
    },
    addNotificationHeading: {
        textAlign: 'left',
        font: 'normal normal bold 24px/29px Montserrat',
        letterSpacing: '0px',
        color: '#272727',
        opacity: '1',
        marginBottom: '15px'
    },
    boxContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'space-around'
    },
    inputContainer: {
        marginBottom: '24px !important',
    },
    field: {
        marginTop: '4px !important',
       '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: '#d6d6d6',
          },
          '&:hover fieldset': {
            borderColor: '#black',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#a6a6a6',
          },
        },
    },
    textBorderColor:{
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: '#d6d6d6',
          },
          '&:hover fieldset': {
            borderColor: '#black',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#a6a6a6',
          },
        },
    },
    autoCompleteField: {
        border: '0.1px solid #d6d6d6 !important',
        overflow: 'auto',
        marginTop: '4px !important',
        maxHeight: '300px',
        borderRadius: '4px',
        boxShadow: 'inset 0 0.1px 0 #d6d6d6',
        // borderTopWidth: '0.1px',
        // borderBottomWidth: '0.1px',
        '&:hover': {
            boxShadow: 'inset 0 1px 0 #d6d6d6 !important',
        },
    },
    fieldLabels: {
        textAlign: 'left',
        font: 'normal normal normal 12px/15px Montserrat',
        letterSpacing: '0px',
        color: '#4E4E4E',
        opacity: 1,
        fontWeight: '800',
        // marginBottom: '7px'
    },
    descriptionField: {
        marginBottom: '4px !important'
    },
    inputFields: {
        border: '1px solid #E9EBF0 !important',
        borderRadius: '7px'
    },
    importantNotification: {
        marginLeft: '0px !important',
    },
    importantNotificationLabel: {
        font: 'normal normal 600 14px/18px Montserrat',
        letterSpacing: '0px !important',
        color: '#4E4E4E',
        opacity: 1,
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',

        '& button' : {
        textAlign: 'left',
        fontFamily: 'OpenSans, sans-serif',
        fontWeight: '500',
        fontSize: '12px !important'
        }
    },
    CancelButton: {
        width: '118px !important',
        height: '43px !important'
    },
    savePreviewButton: {
        width: '141px !important',
        height: '43px !important',
        paddingLeft: '5px !important',
        paddingRight: '5px !important',
        '&.Mui-disabled': {
            fontFamily: 'OpenSans, sans-serif',
            fontWeight: '600',
            fontSize: '16px',
            backgroundColor: '#F2F2F2 !important',
            color: '#4E4E4E !important',
            opacity: 0.5,
        },
    },
    draftButton: {
        width: '161px !important',
        height: '43px !important',
        padding: '0px 5px 0px 8px !important',
        backgroundColor: '#6F96F9 !important',
        minWidth: '112px !important',
        justifyContent: 'space-between !important',
        color: 'white !important',
        letterSpacing: '0px',
        '&.Mui-disabled': {
            fontFamily: 'OpenSans, sans-serif',
            fontWeight: '600',
            fontSize: '16px',
            backgroundColor: '#F2F2F2 !important',
            color: '#4E4E4E !important',
            opacity: 0.5,
        },
    },
    publishIcons: {
        display: 'flex !important',
        backgroundColor: '#598ADC !important',
        borderTopLeftRadius: '0px !important',
        borderBottomLeftRadius: '0px !important',
        borderTopRightRadius: '4px !important',
        borderBottomRightRadius: '4px !important',
        justifyContent: 'space-between !important',
        color: 'white !important',
        '&.Mui-disabled': {
            backgroundColor: '#F2F2F2 !important',
            opacity: 1,
            font: 'normal normal 600 16px/22px Open Sans',
            color: '#4E4E4E !important',
            letterSpacing: 0,
        },
    },
    uploadField: {
        padding: '2px 14px',
        border: '1px solid rgb(197, 197, 197)',
        borderRadius: '4px',
        marginBottom: '10px !important',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        width: '100%',
        background: 'transparent'
    },
    uploadErrorField: {
        borderColor: 'red',
    },
    fileUpload: {
        display: 'none'
    },
    publishModalHeading: {
        font: 'normal normal 600 16px/24px Montserrat !important',
        letterSpacing: '0px',
        color: '#666666',
        opacity: 1,
    },
    publishButtons: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        gap: '8px'
    },
    publishButtonDimensions: {
        height: '34px !important',
        width: '80px !important'
    },
    publishOptions: {
        '& .MuiFormControlLabel-label': {
            font: 'normal normal normal 14px/28px Montserrat',
            color: '#4E4E4E'
        },
        '& .MuiInputBase-input': {
            textAlign: 'left',
            font: 'normal normal normal 14px/18px Montserrat',
            letterSpacing: '1.5px !important',
            color: '#4E4E4E',
            opacity: '1',
            fontWeight: 'bold'
        }
    },
    inputError: {
        color: "#bf3333 !important",
        marginLeft: "16px !important",
        textAlign: 'right !important'
    },
    uploadButtonGroup: {
        display: 'flex',
        alignItems: 'center'
    },
    table: {
        marginTop: '20px',
        marginLeft: '10px',
        border: '0px !important',
        '& .MuiDataGrid-columnHeaderTitle': {
            fontFamily: 'OpenSans, sans-serif !important',
            fontWeight: '600 !important',
            fontSize: '13px !important',
            letterSpacing: '0px !important'
        }
    },
    customPagination: {
        '& .MuiPagination-root .MuiPagination-ul': {
            flexWrap: 'nowrap'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child svg, & .MuiPagination-root .MuiPagination-ul li:last-child svg':
        {
            display: 'none'
        },
        '& .MuiPagination-root .MuiPagination-ul li:last-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child > button, & .MuiPagination-root .MuiPagination-ul li:last-child > button::before':
        {
            margin: '0px 5px'
        },
        paddingTop: '20px'
    },

    '& .MuiDataGrid-row': {
        paddingBottom: '16px !important'
    },

    '& .MuiOutlinedInput-notchedOutline': {
        borderTopWidth: '1px',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.light,
      },
    showPaginationDesc: {
        float: 'left',
        position: 'absolute',
        left: '0px',
        fontFamily: 'OpenSans, sans-serif',
        fontWeight: '500',
        fontSize: '13px',
        color: '#666666'
    },
    pageItem: {
        border: '1px solid #E9EBF0 !important',
        margin: '0px !important',
        borderRadius: '0px !important',
        height: '32px !important',
        '& button::after': {
            margin: '0px'
        }
    },
    notificationButton: {
        '&:hover, &:focus': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            textDecoration: 'none',
            color: 'white !important',
            borderColor:  `${theme.palette.primary.main} !important`
        },
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        width: '134px',
        height: '37px',
        fontSize: theme.palette.textSizeLarge,
    },
    statusContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        font: 'normal normal normal 12px/18px Montserrat',
        fontWeight: 'bold',
        letterSpacing: '0px',
        marginBottom: '0px',
        marginTop: '0px',
        justifyContent: 'center',
        padding: '6px',
        borderRadius: '10px',
        width: '200px'
    },
    statusHeading: {
        marginBottom: '0px',
        marginTop: '0px'
    },
    statusDate: {
        marginBottom: '0px',
        marginTop: '0px'
    },
    published: {
        backgroundColor: '#CAF8D0',
        color: '#087922',
    },
    draft: {
        backgroundColor: '#F8F6CA',
        color: '#96960B',
    },
    scheduled: {
        backgroundColor: '#DFF4FF',
        color: '#55C6FF',
    },
    actionGroup: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    notificationDeleteContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    deleteModalHeading: {
        textAlign: 'center',
        font: 'normal normal 600 16px/16px Montserrat !important',
        letterSpacing: '0px',
        color: '#666666',
        opacity: 1,
        paddingTop: '20px'
    },
    deleteButtonDimensions: {
        height: '34px !important',
        width: '80px !important'
    },
    deleteButtonGroup: {
        display: 'flex',
        gap: '6px',
        paddingTop: '28px',
    },
    menuItems: {
        padding: '0px 10px 0px 10px !important',
        width: '160px !important'
    },
    noNotificationContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems:'center'
    },
    uploadIconContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '4px',
        gap: '4px'
    },
    selectProduct: {
        marginTop: '4px',
        '& .MuiSelect-select': {
            padding: '12px 14px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d6d6d6 !important',
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d6d6d6 !important',
          },
          '& .MuiInputLabel-root': {
            display: 'block', // Ensure the label is displayed properly
          },
          '& .MuiSelect-icon': {
            color: '#000', // Customize the dropdown icon color
          },
        
    },
    characterCount: {
        textAlign: 'left',
        font: 'normal normal normal 14px/18px Montserrat',
        letterSpacing: '0px',
        color: '#4E4E4E',
        opacity: '1',
        position: 'absolute',
        zIndex: 1,
        right: '14px',
        top: '24px',
    },
    characterCountError: {
        right: '14px',
        position: 'absolute',
        top: '24px',
    },
    root : {
        fontFamily: 'OpenSans, sans-serif !important',
        fontWeight: '600 !important',
        fontSize: '13px !important',
        letterSpacing: '0px !important'
    },
    customToggleSwitch: {
        width: 40,
        height: 22,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 1.5,
            '&.Mui-checked': {
                transform: 'translate(25px, 11.5px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#7290F8', 
                    opacity: 1,
                    border: 'none',
                },
            },
        },
        '& .MuiSwitch-thumb': {
            width: 12,
            height: 12,
            boxShadow: 'none',
            backgroundColor: '#fff', 
            transition: 'all 0.3s ease',
        },
        '& .MuiSwitch-track': {
            width: '77%',
            borderRadius: 11,
            backgroundColor: 'transparent', 
            opacity: 1,
            border: '1px solid #9E9E9E', 
            boxSizing: 'border-box',
            transition: 'all 0.3s ease',
        },
        '& .MuiSwitch-switchBase:not(.Mui-checked)': {
            transform: 'translate(11.5px, 11.5px)',
            '& .MuiSwitch-thumb': {
                backgroundColor: '#616161', 
            },
        },
    },
}));
